import React from 'react';
import Link from 'next/link';

interface IProps {
  url?: string;
  icon?: React.JSX.Element | null;
  title?: string;
}

const SocialMediaBadge: React.FC<IProps> = ({ url, icon, title }) => (
  <Link
    href={url!}
    target='_blank'
    className="flex h-full w-full cursor-pointer items-center justify-center gap-1 rounded-lg bg-gray-100 py-2 text-xs font-semibold"
  >
    <span>{icon}</span>
    <span className='capitalize'>{title}</span>
  </Link>
);

export default SocialMediaBadge;
